const AboutProcess = () => {
  const steps = [
    {
      number: '01',
      title: 'Kennismaking',
      description: 'We bespreken uw wensen, budget en planning tijdens een vrijblijvend gesprek.'
    },
    {
      number: '02',
      title: 'Offerte',
      description: 'U ontvangt een gedetailleerde offerte met alle kosten en werkzaamheden.'
    },
    {
      number: '03',
      title: 'Planning',
      description: 'We maken een duidelijk tijdschema en plannen alle werkzaamheden in.'
    },
    {
      number: '04',
      title: 'Uitvoering',
      description: 'Ons team gaat aan de slag met uw project, met regelmatige updates.'
    },
    {
      number: '05',
      title: 'Oplevering',
      description: 'We leveren het project op en zorgen dat u 100% tevreden bent.'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'serif' }}>
            Onze Werkwijze
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Van eerste contact tot oplevering - een duidelijk proces
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="text-center">
                <div className="inline-flex items-center justify-center w-20 h-20 bg-gray-900 text-white rounded-full text-2xl font-bold mb-6" style={{ fontFamily: 'serif' }}>
                  {step.number}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-sm">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-full w-full h-px bg-gray-200 -translate-x-1/2"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutProcess;